(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if ('ResizeObserver' in window) {
        this.headerHeightObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.headerHeightObserver.observe(this.header);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.headerHeightObserver) this.headerHeightObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  const DIRHAM_ICON_HTML =
    '<span class="dirham-icon aed-icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" data-test="aed-icon"><path d="M11.036 3c2.215 0 4.034.56 5.457 1.679 1.431 1.12 2.362 2.686 2.79 4.699h2.026c.21 0 .375.13.497.387.129.25.194.66.194 1.232h-2.486c.016.322.024.648.024.979 0 .467-.02.926-.06 1.376h1.83c.21 0 .376.13.498.387.129.25.194.66.194 1.233h-2.814c-.477 1.908-1.43 3.39-2.862 4.445C14.901 20.472 13.077 21 10.854 21H4.972v-6.028h-2.28c-.21 0-.381-.113-.51-.338C2.06 14.4 2 13.973 2 13.352h2.972v-2.355h-2.28c-.21 0-.381-.112-.51-.338C2.06 10.426 2 9.998 2 9.378h2.972V3h6.064ZM7.75 18.584h2.947c1.504 0 2.73-.307 3.675-.919.946-.62 1.618-1.518 2.014-2.693H7.749v3.612Zm0-5.232h8.999c.049-.434.073-.893.073-1.376 0-.339-.012-.665-.036-.979H7.75v2.355Zm0-3.974h8.757c-.356-1.288-1.007-2.27-1.953-2.947-.946-.677-2.18-1.015-3.7-1.015H7.75v3.962Z" fill="currentColor"></path></svg></span>';
  const DISCOUNT_MODAL_STORAGE_KEY = 'mawwalCartDiscountUnlocked';

  function cartProgressBarFormatAmount(cents) {
    return (Math.ceil((parseInt(cents, 10) || 0) / 100)).toString();
  }

  function cartProgressBarMoneyHtml(cents) {
    return DIRHAM_ICON_HTML + cartProgressBarFormatAmount(cents);
  }

  function closeCartDiscountModal() {
    const modal = document.getElementById('cart-discount-modal');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.removeProperty('overflow');
  }

  function openCartDiscountModal(force) {
    const modal = document.getElementById('cart-discount-modal');
    if (!modal) return;
    if (!force && sessionStorage.getItem(DISCOUNT_MODAL_STORAGE_KEY) === '1') return;

    sessionStorage.setItem(DISCOUNT_MODAL_STORAGE_KEY, '1');
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });
    document.documentElement.style.overflow = 'hidden';
  }

  function updateCartProgressBar(totalCents, itemCount) {
    const bar = document.getElementById('cart-progress-bar');
    if (!bar) return;

    if (itemCount === 0) {
      bar.setAttribute('hidden', '');
      bar.dataset.unlocked = 'false';
      sessionStorage.removeItem(DISCOUNT_MODAL_STORAGE_KEY);
      closeCartDiscountModal();
      return;
    }
    bar.removeAttribute('hidden');

    const threshold = parseInt(bar.dataset.thresholdCents, 10);
    const discount = parseInt(bar.dataset.discountCents, 10);
    const remaining = Math.max(threshold - totalCents, 0);
    const percent = Math.min((totalCents / threshold) * 100, 100);
    const wasUnlocked = bar.dataset.unlocked === 'true';
    const isUnlocked = remaining === 0;

    const fill = bar.querySelector('.cart-progress-bar__fill');
    const text = bar.querySelector('.cart-progress-bar__text');
    if (fill) fill.style.width = percent + '%';
    if (text) {
      text.innerHTML = remaining > 0
        ? 'Add ' + cartProgressBarMoneyHtml(remaining) + ' more &amp; get ' + cartProgressBarMoneyHtml(discount) + ' OFF'
        : 'You unlocked ' + cartProgressBarMoneyHtml(discount) + ' OFF!';
    }

    bar.dataset.unlocked = isUnlocked ? 'true' : 'false';

    if (isUnlocked && !wasUnlocked) {
      openCartDiscountModal(true);
    } else if (!isUnlocked) {
      sessionStorage.removeItem(DISCOUNT_MODAL_STORAGE_KEY);
    }
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-discount-modal-close]')) {
      closeCartDiscountModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCartDiscountModal();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.cartData) {
        const itemTotal =
          typeof event.cartData.items_subtotal_price === 'number'
            ? event.cartData.items_subtotal_price
            : event.cartData.total_price;
        updateCartProgressBar(itemTotal, event.cartData.item_count);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    const bar = document.getElementById('cart-progress-bar');
    if (bar && bar.dataset.unlocked === 'true' && !bar.hasAttribute('hidden')) {
      openCartDiscountModal(false);
    }

    function syncCartProgressStickyTop() {
      const progressBar = document.getElementById('cart-progress-bar');
      const header = document.querySelector('.section-header');
      if (!progressBar || !header || progressBar.hasAttribute('hidden')) return;
      const headerBottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      progressBar.style.top = headerBottom + 'px';
    }

    syncCartProgressStickyTop();
    window.addEventListener('scroll', syncCartProgressStickyTop, { passive: true });
    window.addEventListener('resize', syncCartProgressStickyTop);
  });

  } catch(e) { console.error(e); }
})();
})();
